import React, { useEffect, useState } from 'react';
import { WifiOff, RefreshCw, CloudUpload, AlertTriangle, X, ChevronDown, ChevronUp } from 'lucide-react';
import { offlineStore, sync, retryFailed, discardItem, discardAllFailed } from '../offline/offlineManager';

export const OfflineBanner = () => {
  const [s, setS] = useState(offlineStore.getSnapshot());
  const [open, setOpen] = useState(false);
  useEffect(() => offlineStore.subscribe(setS), []);

  const hasFailed = s.failed > 0;
  if (s.online && s.pending === 0 && !hasFailed && !s.syncing) return null;

  const tone = !s.online ? 'bg-amber-500 text-amber-950' : hasFailed ? 'bg-red-600 text-white' : 'bg-emerald-600 text-white';

  return (
    <div className={`sticky top-0 z-[60] ${tone} shadow-md`} data-testid="offline-banner">
      <div className="px-4 py-2 flex items-center gap-3 text-sm font-medium">
        {!s.online ? <WifiOff className="w-4 h-4 shrink-0" /> : s.syncing ? <RefreshCw className="w-4 h-4 shrink-0 animate-spin" /> : hasFailed ? <AlertTriangle className="w-4 h-4 shrink-0" /> : <CloudUpload className="w-4 h-4 shrink-0" />}
        <span className="flex-1" data-testid="offline-banner-text">
          {!s.online && (
            <>Hors ligne — vous voyez les dernières données chargées.
              {s.pending > 0 ? ` ${s.pending} modification${s.pending > 1 ? 's' : ''} en attente, envoi automatique au retour du réseau.` : ' Vos modifications seront enregistrées au retour du réseau.'}</>
          )}
          {s.online && s.syncing && <>Synchronisation en cours… {s.pending} restante{s.pending > 1 ? 's' : ''}</>}
          {s.online && !s.syncing && hasFailed && <>{s.failed} modification{s.failed > 1 ? 's' : ''} hors ligne refusée{s.failed > 1 ? 's' : ''} par le serveur</>}
          {s.online && !s.syncing && !hasFailed && s.pending > 0 && <>{s.pending} modification{s.pending > 1 ? 's' : ''} en attente d'envoi</>}
        </span>
        {s.online && s.pending > 0 && !s.syncing && (
          <button onClick={() => sync()} className="px-2.5 py-1 rounded bg-white/20 hover:bg-white/30 text-xs" data-testid="offline-sync-now-btn">Synchroniser</button>
        )}
        {hasFailed && (
          <>
            <button onClick={() => retryFailed()} className="px-2.5 py-1 rounded bg-white/20 hover:bg-white/30 text-xs" data-testid="offline-retry-btn">Réessayer</button>
            <button onClick={() => setOpen(!open)} className="p-1 rounded hover:bg-white/20" data-testid="offline-toggle-details-btn">{open ? <ChevronUp className="w-4 h-4" /> : <ChevronDown className="w-4 h-4" />}</button>
          </>
        )}
      </div>
      {hasFailed && open && (
        <div className="bg-white text-slate-800 border-b border-red-200 px-4 py-3 space-y-2 text-sm" data-testid="offline-failed-list">
          {s.failedItems.map((it) => (
            <div key={it.id} className="flex items-start gap-3" data-testid={`offline-failed-item-${it.id}`}>
              <div className="flex-1">
                <div className="font-medium">{it.label}</div>
                <div className="text-xs text-red-600">{it.error}</div>
              </div>
              <button onClick={() => discardItem(it.id)} className="text-xs text-slate-500 hover:text-red-600 inline-flex items-center gap-1" data-testid={`offline-discard-${it.id}`}>
                <X className="w-3.5 h-3.5" /> Abandonner
              </button>
            </div>
          ))}
          <button onClick={() => discardAllFailed()} className="text-xs text-slate-500 hover:text-red-600 underline" data-testid="offline-discard-all-btn">Tout abandonner</button>
        </div>
      )}
    </div>
  );
};

export default OfflineBanner;
